<template>
    <transition name="fade">
        <div class="WebsiteDialogue" v-show="websiteDialogueVisible">
            <div class="wd-container">
                
                <!-- Toolbar -->
                <div class="wd-bar">
                    <p class="wd-bar-name">{{ $t(name ? name : type) }}</p>
                    <md-button class="md-icon-button wd-bar-close" @click="toggleWebsiteDialogue(false)" style="margin-right: 0;" :md-ripple="false" :class="{'followModeratorDisableButton': followModeratorMode}">
                        <CloseIcon/>
                    </md-button>
                </div>

                <!-- Content -->
                <div class="wd-content swiper" id="wd-content" v-if="type == 'Bildergalerie' || type == 'Videothek' || type == 'Dokumente'">

                    <!-- Bildergalerie -->
                    <div v-if="type == 'Bildergalerie'" class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(img,i) in content" :key="img.url">
                            <img class="wd-swiper-img" :src="'https://imageservice.production.denios.io/live-asset.denios-2020.de/article/'+ img.filename +'/inside:1000x0.webp'" @click="swipeTo(i)" :style="{'cursor': i != swiperIndex ? 'pointer' : 'default'}" alt="" draggable="false">
                        </div>
                    </div>

                    <!-- Videothek -->
                    <div v-if="type == 'Videothek'" class="swiper-wrapper">
                        <div class="swiper-slide" v-for="video in content" :key="video.url">
                            <div class="wd-swiper-video">
                                <iframe class="wd-iframe" :src="video" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>

                    <!-- Dokumente -->
                    <div v-if="type == 'Dokumente'" class="swiper-wrapper">
                        <div class="swiper-slide" v-for="document in content" :key="document.src">
                            <div class="wd-swiper-document">
                                <img class="wd-swiper-document-icon" :src="publicPath+'/media'+mediaURL+'/data/icons/icDocuments_white.svg'" alt="">
                                <div class="wd-swiper-document-language">{{document.languages}}</div>
                                <div class="wd-swiper-document-title">{{ $t(document.src.split("/").at("-1")) }}</div>
                                <div class="wd-swiper-document-link" @click="openURL(document.src)">{{ $t('Dokument ansehen ➝') }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-button-next" :class="{'followModeratorDisableButton': followModeratorMode}"/>
                    <div class="swiper-button-prev" :class="{'followModeratorDisableButton': followModeratorMode}"/>
                </div>

                <!-- Website -->
                <div class="wd-content" v-if="type == 'Website'">
                    <iframe class="wd-iframe" :src="content.url" frameborder="0"/>
                </div>

                <!-- Video -->
                <div class="wd-content" v-if="type == 'Video'">
                    <iframe class="wd-iframe" :src="content.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>

                <!-- PDF -->
                <div class="wd-content" v-if="type == 'InformationPDF' || type == 'Schadensfall'" style="background: white; user-select: none;">
                    <iframe class="wd-iframe" :src="publicPath + '/media'+mediaURL+'/data/Digital%20Services/content/'+ activeLanguage.shortCode + '-' + activeRegion.id + '/' + content" frameborder="0" toolbar="0"/>
                </div>

            </div>         

        </div>  
    </transition>
</template>

<script>
import {mapMutations,mapActions,mapGetters} from 'vuex';

import Swiper, {Navigation} from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/modules/navigation/navigation.min.css'

import axios from 'axios';

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'

export default {
    components: {CloseIcon},
    data: function () {
        return {
            publicPath: process.env.BASE_URL,
            websiteDialogueVisible: false,
            name: "",
            sku: "",
            type: "",
            content: null,
            swiperIndex: 0,
        }
    }, 
    computed: {
        ...mapGetters(["mediaURL","followModeratorMode","sendingFollowModerator","activeLanguage","activeRegion"])
    },
    watch: {
        followModeratorMode(){
            if(this.followModeratorMode && this.websiteDialogueVisible)
                this.toggleWebsiteDialogue(false);
        },
    },
	methods: {
        ...mapActions(["sendCommand"]),
        ...mapMutations(["setDialogueOpen"]),
        toggleWebsiteDialogue(bool){
            if(this.sendingFollowModerator)
                this.sendCommand({type: "CommandSendEvent", data: {eventName: "openURL", state: bool, content: this.content, type: this.type, sku: this.sku, name: this.name}});
            
            if(bool != this.viewer3DVisible){
                this.websiteDialogueVisible=!this.websiteDialogueVisible;
                this.setDialogueOpen(this.websiteDialogueVisible);

                // Close Product Menu
                window.dispatchEvent(new CustomEvent("closeOtherProductMenus", {detail:{this: undefined}}));
                
                setTimeout(() => {
                    if(!this.websiteDialogueVisible){
                        this.type = "";
                        this.sku = 0;
                        this.name = "";
                        this.content = null; 
                    }   
                }, 500);           
            }
        },
        initSwiper(){
            if(this.swiper && this.swiper.length == 2)
                this.swiper[0].destroy(true,true);
            else if(this.swiper)
                this.swiper.destroy(true,true);

            setTimeout(() => {
                this.swiper = new Swiper('#wd-content',{
                    modules: [Navigation],
                    // loop: true, //TODO: Fix error when enabling Loop
                    centeredSlides: true,
                    slidesPerView: "auto",
                    spaceBetween: "-20%",
                    noSwiping: true,
                    allowTouchMove: false,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });

                this.swiper.on('slideChange',(swiper) => {
                    this.swiperIndex = swiper.activeIndex;

                    if(this.sendingFollowModerator)
                        this.sendCommand({type: "CommandSendEvent", data: {eventName: "changeSlide", swiperIndex: this.swiperIndex}});
                });
            }, 0); 
        },
        swipeTo(i){
            if(!this.followModeratorMode)
                this.swiper.slideTo(i);
        },
        openURL(url){
            window.open(url, '_blank').focus();
        },
        async getProductJson(sku){
            let tokenData = await axios("https://auth.europe-west1.gcp.commercetools.com/oauth/token?grant_type=client_credentials", {
                method: 'POST',
                headers: {
                    'Authorization': 'Basic czRuMTNzUjNqUnBpSUUzMmN3VnI5TzhmOkl4VVBkbDhiUEtEMWpNOE0xalNZUjBiWkFNR1BPVlhp'
                }
            })
                
            let productJson = axios("https://api.europe-west1.gcp.commercetools.com/denios_develop/products/key="+sku, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + tokenData.data.access_token
                }
            })
            
            return productJson;
        }
    },
    mounted(){
        window.addEventListener('openURL', async (e) => {
            console.log("OpenURL Detail Object:",e.detail);
            this.type = e.detail.type;
            this.content = e.detail.content;
            this.sku = e.detail.sku;
            this.name = e.detail.name;

            if(this.type == "InformationPDF"){
                this.content = e.detail.content.replaceAll(" ","%20");
            }

            if(this.type == "Bildergalerie" || this.type == "Videothek" || this.type == "Dokumente")
                setTimeout(() => { this.initSwiper(); }, 100);
                
            if(this.type == "Bildergalerie"){
                let productJson = (await this.getProductJson(this.sku)).data;
                let attributes = productJson.masterData.current.masterVariant.attributes;
                this.content = JSON.parse(attributes.find(attribut => attribut.name === "images_meta_data").value["de-DE"]); 
            }

            if(this.type == "Video" && this.content.url.includes("youtube")){
                this.content.url = this.content.url.replace("watch?v=","embed/");
                
                if(!this.content.url.includes("?")){
                    var index = this.content.url.indexOf("&")
                    if(index>-1){
                        // Change first '&' to '?'
                        this.content.url = this.content.url.substring(0,index) + "?" + this.content.url.substring(index+1);
                    } else {
                        this.content.url += "?"
                    }
                }
                if(!this.content.url.includes("&autoplay=1")) this.content.url += "&autoplay=1";
            }

            if(this.type == "Videothek"){
                console.log("Videothek content:",this.content);
                console.log(this.activeLanguage.shortCode);

                var langVideos = [];
                this.content.forEach(video => {
                    var vid;
                    switch(this.activeLanguage.shortCode){
                        case "de": vid = video.lang_urls.de ? video.lang_urls.de : video.lang_urls.default; break;
                        case "en": vid = video.lang_urls.en ? video.lang_urls.en : video.lang_urls.default; break;
                        case "it": vid = video.lang_urls.it ? video.lang_urls.it : video.lang_urls.default; break;
                        case "pl": vid = video.lang_urls.pl ? video.lang_urls.pl : video.lang_urls.default; break;
                        case "nl": vid = video.lang_urls.nl ? video.lang_urls.nl : video.lang_urls.default; break;
                        case "fr": vid = video.lang_urls.fr ? video.lang_urls.fr : video.lang_urls.default; break;
                        case "cs": vid = video.lang_urls.cs ? video.lang_urls.cs : video.lang_urls.default; break;
                        case "sk": vid = video.lang_urls.sk ? video.lang_urls.sk : video.lang_urls.default; break;
                        case "da": vid = video.lang_urls.da ? video.lang_urls.da : video.lang_urls.default; break;
                        case "ds": vid = video.lang_urls.ds ? video.lang_urls.ds : video.lang_urls.default; break;
                        case "fi": vid = video.lang_urls.fi ? video.lang_urls.fi : video.lang_urls.default; break;
                        case "sv": vid = video.lang_urls.sv ? video.lang_urls.sv : video.lang_urls.default; break;
                    }
                    vid = vid.replace("watch?v=","embed/");
                    langVideos.push(vid);
                })
                this.content = langVideos;
                console.log(this.content);

                // this.content.forEach(video => {
                //     video = video.replace("watch?v=","embed/");
                //     console.log(video);
                // });
            }

            this.toggleWebsiteDialogue(e.detail.state == undefined ? true : e.detail.state);
        });

        window.addEventListener('changeSlide',(e) => {
            this.swiper.slideTo(e.detail.swiperIndex);
        });

        window.addEventListener('onUserJoined',() => {
            if(this.websiteDialogueVisible)
                this.sendCommand({type: "CommandSendEvent", data: {eventName: "openURL", content: this.content, type: this.type, sku: this.sku, name: this.name}});
        });
    }
}
</script>

<style>
    .WebsiteDialogue{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
        z-index: 10;
    }
    .wd-container{
        position: absolute;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        overflow: hidden;
        width: 90%;
        height: 90%;
    }
    .wd-content{
        width: 100%;
        height: calc(100% - 46px) !important;
        overflow-x: hidden;
        border-radius: 0px 0px 10px 10px;
        background: var(--deniosBackground);
        overflow: hidden;
    }

    /* Toolbar */
    .wd-bar{
        display: flex;
        position: relative;
        height: 40px;
        background: white;
    }
    .wd-bar-name{
        width: 100%;
        text-align: center;
        margin: auto 0;
        color: var(--deniosGraySecondary);
        font: normal normal 100 21px/31px Oswald;       
    }
    .wd-bar-close{
        background: var(--primaryColor) !important;
        position: absolute;
        right: 0;
        padding: 5px;
        border-radius: 0;
        margin-right: 0;
    }
    .wd-bar-close::before, .wd-bar-back::before{
        border-radius: 0;
    }
    .material-design-icon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon > .material-design-icon__svg {
        fill: white;
        height: 2.5em;
        width: 2.5em;
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
        margin-left: 0;
    }

    /* Swiper */
    .swiper-button-disabled{
        opacity: 0.1;
    }
    .swiper-button-next, .swiper-button-prev{
        background: #5a5a5a;
        color: white;
        padding: 50px 25px;
        font-size: 30px;
        font-weight: bold;
        top: calc(50% - 50px);
        transition: background .4s ease;
    }
    .swiper-button-next::after, .swiper-button-prev::after{
        font-size: 20px !important;
    }
    .swiper-button-next:hover, .swiper-button-prev:hover{
        background: var(--primaryColor);
    }
    .swiper-button-next{
        right: 0;
        border-radius: 5px 0px 0px 5px;
    }
    .swiper-button-prev{
        left: 0;
        border-radius: 0px 5px 5px 0px;
    }
    .WebsiteDialogue .swiper-slide{
        width: min(80%, 800px);;
        transform: scale(0.5);
        color: var(--deniosDark) !important;
        opacity: 0;

        transition: all 200ms ease-in-out;
    }
    .WebsiteDialogue .swiper-slide-active{
        transform: scale(1);
        opacity: 1;
        z-index: 1;
    }
    .WebsiteDialogue .swiper-slide-prev, .WebsiteDialogue .swiper-slide-next{
        transform: scale(0.8);
        opacity: 0.8;
    }

    /* Website */
    .wd-iframe{
        width: 100%;
        height: 100% !important;
    }

    /* Bildergalerie */
    .wd-swiper-img, .wd-swiper-video{
        height: calc(80% - 46px) !important;
        width: 100%;
        margin-bottom: 20px;
        object-fit: contain;
        user-select: none;
        filter: drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.3));
    }
    .wd-swiper-title{
        margin-top: 15px;
        margin-bottom: 8px;
        width: 50%;
        text-align: center;
        font: normal normal 500 18px/22px Oswald;
        letter-spacing: 1.35px;
    }
    .wd-swiper-description{
        text-align: center;
        width: 50%;
        font: normal normal 100 15px/18px Roboto;
    }
    .wd-swiper-thumbnail{
        height: 100%;
        width: 100%;
        z-index: 1;
        position: absolute;
        transition: opacity .3s ease;
        cursor: pointer;
    }
    .wd-swiper-playButton{
        position: absolute;
        z-index: 1;
        top: calc(50% - 35px);
        left: calc(50% - 35px);
        width: 70px;
        height: 70px;
        filter: drop-shadow(0px 0px 10px black);
        transition: filter .3s ease, transform .3s ease;
        pointer-events: none;
    }
    .wd-swiper-thumbnail:hover .wd-swiper-playButton{
        filter: drop-shadow(0px 0px 10px rgb(105, 105, 105));
        transform: scale(1.2);
    }
    .wd-swiper-thumbnail img:last-child{
        filter: brightness(0.5);
    }

    /* Documents */
    .wd-swiper-document{
        width: min(80%, 400px);;
        height: min(60%, 420px);;
        padding-left: 25px;
        border-radius: 7px;
        background: white;
        filter: drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.3));
        overflow: hidden;
    }
    .wd-swiper-document-language{
        color: var(--deniosBlueSecondary);
        margin-bottom: 5px;
        font: normal normal 100 15px/22px Oswald;
        letter-spacing: 1.35px;
    }
    .wd-swiper-document-title{
        margin-bottom: 15px;
        padding-right: 70px;
        font: normal normal 100 21px/31px Oswald;
        letter-spacing: 1.89px;
    }
    .wd-swiper-document-description{
        margin-bottom: 25px;
        padding-right: 70px;
        font: normal normal 100 15px/22px Roboto;
    }
    .wd-swiper-document-link{
        color: var(--primaryColor);
        cursor: pointer;
        transition: color .2s ease;
        font: normal normal 500 17px/24px Roboto;
        display: inline-block;
    }
    .wd-swiper-document-link:hover{
        color: #667c96;
    }
    .wd-swiper-document-icon{
        height: 40px;
        width: 40px;
        display: block;
        margin-left: auto;
        background: var(--primaryColor);
        padding: 15px;
        border-radius: 0px 0px 0px 7px;
        margin-bottom: 10px;
    }

    /* Mobile */
    @media (max-device-width: 900px){
        .wd-screen{
            z-index: 99;
        }
    }
</style>
    